export type AuthMethod = 'certificate' | 'checkedid' | 'csc' | 'csc_preview' | 'digid' | 'digid_preview' | 'document_anchors'| 'documenttemplate' |
    'idin' | 'idin_preview' | 'irma' | 'irma_preview' | 'mouse' | 'mouse_preview' | 'smstan' | 'smstan_preview' | 'sso' | 'sso_preview' ;

export const AuthMethodsArray: AuthMethod[] = ['certificate', 'checkedid', 'csc', 'digid', 'document_anchors', 'documenttemplate', 'idin', 'irma', 'mouse', 'smstan', 'sso'];
export const PreviewMethodsArray: AuthMethod[] =  ['digid_preview', 'idin_preview', 'irma_preview', 'smstan_preview', 'sso_preview', 'csc_preview'];

export const ExclusiveMethodsArray: AuthMethod[] = ['csc', 'documenttemplate', 'mouse', 'document_anchors'];

export const GlobalMethodsArray: AuthMethod[] = ['documenttemplate', 'document_anchors'];

/**
 * Array with the AMs which are available in an eDelivery request
 */
export const EdeliveryAuthMethodsArray = ['digid_preview', 'idin_preview', 'irma_preview', 'mouse_preview', 'smstan_preview', 'csc_preview'];

/**
 * Pairs of exclusive methods that are ALLOWED to coexist.
 * All other combinations within ExclusiveMethodsArray remain mutually exclusive.
 */
const COMPATIBLE_PAIRS: [AuthMethod, AuthMethod][] = [
    ['document_anchors', 'documenttemplate'],
];

/**
 * Returns true if two exclusive methods are allowed to be active at the same time.
 * Use this instead of a simple ExclusiveMethodsArray.includes() conflict check.
 */
export function areMethodsCompatible(methodA: AuthMethod, methodB: AuthMethod): boolean {
    if (methodA === methodB) return true;
    return COMPATIBLE_PAIRS.some(
        ([a, b]) => (a === methodA && b === methodB) || (a === methodB && b === methodA)
    );
}
